import { CHeliSkyway } from './skywaylib/CHeliSkyway';
import { CHeliNetworkCallback } from './CHeliNetworkCallback';
var g_pIHeliNetwork = null;
export const CreateHeliNetwork = ()=>{
    SetIHeliNetwork(new CHeliSkyway());
};
const SetIHeliNetwork = (pIHeliNetwork)=>{
    g_pIHeliNetwork = pIHeliNetwork;
    g_pIHeliNetwork.setCallback(new CHeliNetworkCallback());
};
export const GetIHeliNetwork = ()=>{
    return g_pIHeliNetwork;
};
// ひとまずSkyway固定でインターフェイスを生成しておく
CreateHeliNetwork();
